// Footer.jsx
import React from 'react';
import logo1 from "../img/dzyrislogo__1___1_-removebg-preview.png";
import './Footer.css'; // Import the CSS for styling

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section about">
            <img src={logo1} alt="Dzyris Frozen Foods" className="logo" />
          <h3>Dzyris Frozen Foods</h3>
          <p>
            Frozen to perfection, savored with passion!
          </p>
        </div>

        <div className="footer-section links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/home">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/refund-policy">Refund Policy</a></li>
            <li><a href="terms-conditions">Terms & Conditions</a></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h4>Contact Us</h4>
          <p>Email: customersupport@dzyris.in</p>
          <p>Customer Care: +91 8956622450</p>
          <p>Technical Support: +91 9860405100</p>
          <p>Address: Mori gaon Kaman road, Vasai-Virar, Maharashtra, 401209</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Dzyris Infotech. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
